import { SpaceBetween } from "@cloudscape-design/components-themed";
import { Register } from "../components/individual-counseling-project-contents-register/Register";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/* 
個別相談案件相談内容登録画面
 */
const IndividualCounselingProjectContentsRegister = () => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.INDIVIDUAL_COUNSELING);

  return (
    <SpaceBetween size="l">
      <Register />
    </SpaceBetween>
  );
};

export default IndividualCounselingProjectContentsRegister;
